export default "__VITE_ASSET__CHcxJwbf__"